/* eslint-disable no-console */
import { useState, useEffect, useCallback } from 'react';
import axios from 'supports/api';
import cities from '../static/cities';

// Fetches the reference lists the form selects from.
const useScheduleResources = () => {
  const [branches, setBranches] = useState([]);
  const [studyMethods, setStudyMethods] = useState([]);
  const [studySchedules, setStudySchedules] = useState([]);
  const [venues, setVenues] = useState([]);
  const [speakers, setSpeakers] = useState([]);

  const getSpeakers = useCallback(() => {
    axios
      .get(`/admin/speaker/list`)
      .then((res) => {
        setSpeakers(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`/branch/all`)
      .then((res) => {
        setBranches(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get('/program/methods')
      .then((res) => {
        setStudyMethods(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get('/program/schedules')
      .then((res) => {
        setStudySchedules(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get('/program/venues')
      .then((res) => {
        setVenues(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });

    getSpeakers();
  }, [getSpeakers]);

  return {
    branches,
    studyMethods,
    studySchedules,
    venues,
    speakers,
    cities,
    getSpeakers,
  };
};

export default useScheduleResources;
